/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'

type Props = {
  icon: string
  title: string
  description: string
}

const Card4: FC<Props> = ({icon, title, description}) => {
  return (
    <div className='card h-100  '>
      <div className='card-body d-flex justify-content-center text-center flex-column p-2'>
        <a  className='text-gray-800 text-hover-primary d-flex flex-column'>
          <div className='symbol  mb-1' >
            <img src={toAbsoluteUrl(icon)} alt="imagen dec" style={{width:'200px', height:'80px'}} />
          </div>
          <div className='fs-5 fw-bolder mb-1'>{title}</div>
        </a>
        <div className='fs-5 fw-bold text-info mt-auto'>{description}</div>
      </div>
    </div>
  )
}

export {Card4}
